<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header>Add new cover page</h1>

  <app-cover-page-form *ngIf="isOpen" [clientNumbers]="clientNumbers" (save)="onSubmit($event)"></app-cover-page-form>
</app-base-modal>
